import React, { useState, useRef } from 'react';
import { useProducts } from '../context/ProductsContext';
import { FiPlus, FiPrinter, FiShare2, FiX } from 'react-icons/fi';
import jsPDF from 'jspdf';

const BUSINESS = {
  name: 'Shammy Spices',
  phone: '+255 655 778 989',
  email: 'info@shammyspicestz.shop',
  address: 'Dar es Salaam, Tanzania',
  website: 'shammyspicestz.shop',
};

let invoiceCounter = Number(localStorage.getItem('shammy_inv_counter') || 1000);
const nextInvoiceNo = () => {
  invoiceCounter++;
  localStorage.setItem('shammy_inv_counter', invoiceCounter);
  return `INV-${invoiceCounter}`;
};

const AdminInvoice = () => {
  const { products } = useProducts();
  const printRef = useRef(null);

  const [customer, setCustomer] = useState({ name: '', phone: '', address: '' });
  const [lines, setLines] = useState([{ productId: '', name: '', price: 0, qty: 1 }]);
  const [notes, setNotes] = useState('');
  const [invoiceNo] = useState(() => nextInvoiceNo());
  const [date] = useState(() => new Date().toLocaleDateString('en-GB'));
  const [preview, setPreview] = useState(false);

  const setLine = (i, key, val) => {
    setLines(prev => prev.map((l, idx) => idx === i ? { ...l, [key]: val } : l));
  };

  const selectProduct = (i, productId) => {
    const p = products.find(p => String(p.id) === productId);
    if (p) setLines(prev => prev.map((l, idx) => idx === i ? { ...l, productId, name: p.name, price: p.price } : l));
    else setLine(i, 'productId', productId);
  };

  const addLine = () => setLines(prev => [...prev, { productId: '', name: '', price: 0, qty: 1 }]);
  const removeLine = (i) => setLines(prev => prev.filter((_, idx) => idx !== i));

  const subtotal = lines.reduce((s, l) => s + (Number(l.price) * Number(l.qty)), 0);
  const total = subtotal;

  const handlePrint = () => { // eslint-disable-line no-unused-vars
    setPreview(true);
    setTimeout(() => window.print(), 300);
  };

  const handlePDF = () => {
    const doc = new jsPDF({ unit: 'mm', format: 'a5' });
    const w = doc.internal.pageSize.getWidth();
    let y = 15;

    doc.setFontSize(18); doc.setTextColor('#1a4f0c');
    doc.text(BUSINESS.name, w / 2, y, { align: 'center' }); y += 7;
    doc.setFontSize(9); doc.setTextColor('#555');
    doc.text(`${BUSINESS.phone} | ${BUSINESS.email}`, w / 2, y, { align: 'center' }); y += 5;
    doc.text(BUSINESS.address, w / 2, y, { align: 'center' }); y += 10;

    doc.setDrawColor('#1a4f0c'); doc.setLineWidth(0.5);
    doc.line(10, y, w - 10, y); y += 7;

    doc.setFontSize(12); doc.setTextColor('#1a1a1a');
    doc.text('INVOICE', 10, y);
    doc.setFontSize(9); doc.setTextColor('#555');
    doc.text(`No: ${invoiceNo}`, w - 10, y, { align: 'right' }); y += 5;
    doc.text(`Date: ${date}`, w - 10, y, { align: 'right' }); y += 8;

    if (customer.name) {
      doc.setFontSize(9); doc.setTextColor('#1a1a1a');
      doc.text(`Bill To: ${customer.name}`, 10, y); y += 5;
      if (customer.phone) { doc.text(`Phone: ${customer.phone}`, 10, y); y += 5; }
      if (customer.address) { doc.text(`Address: ${customer.address}`, 10, y); y += 5; }
      y += 3;
    }

    doc.setFillColor('#1a4f0c');
    doc.rect(10, y, w - 20, 7, 'F');
    doc.setTextColor('#fff'); doc.setFontSize(9);
    doc.text('Item', 12, y + 5);
    doc.text('Qty', w - 40, y + 5, { align: 'center' });
    doc.text('Price', w - 25, y + 5, { align: 'right' });
    doc.text('Total', w - 11, y + 5, { align: 'right' });
    y += 10;

    lines.filter(l => l.name).forEach((l, i) => {
      doc.setTextColor('#1a1a1a'); doc.setFontSize(9);
      if (i % 2 === 0) { doc.setFillColor('#f8fdf5'); doc.rect(10, y - 3, w - 20, 7, 'F'); }
      doc.text(l.name, 12, y + 1);
      doc.text(String(l.qty), w - 40, y + 1, { align: 'center' });
      doc.text(Number(l.price).toLocaleString(), w - 25, y + 1, { align: 'right' });
      doc.text((Number(l.price) * Number(l.qty)).toLocaleString(), w - 11, y + 1, { align: 'right' });
      y += 7;
    });

    y += 3;
    doc.line(10, y, w - 10, y); y += 6;
    doc.setFontSize(11); doc.setTextColor('#1a4f0c');
    doc.text(`TOTAL: TZS ${total.toLocaleString()}`, w - 11, y, { align: 'right' }); y += 8;

    if (notes) { doc.setFontSize(8); doc.setTextColor('#777'); doc.text(`Notes: ${notes}`, 10, y); y += 6; }

    doc.setFontSize(8); doc.setTextColor('#999');
    doc.text('Thank you for your business!', w / 2, y + 5, { align: 'center' });

    doc.save(`${invoiceNo}.pdf`);
  };

  const handleShare = async () => {
    const text = `*${BUSINESS.name} — Invoice ${invoiceNo}*\nDate: ${date}\n\n` +
      (customer.name ? `Customer: ${customer.name}\n\n` : '') +
      lines.filter(l => l.name).map(l => `• ${l.name} x${l.qty} = TZS ${(Number(l.price) * Number(l.qty)).toLocaleString()}`).join('\n') +
      `\n\n*TOTAL: TZS ${total.toLocaleString()}*\n\n${notes ? `Notes: ${notes}\n\n` : ''}${BUSINESS.website}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="ap-page">
      {preview && <div className="ap-print-notice">Print dialog opened. <button onClick={() => setPreview(false)}>Close</button></div>}

      <div className="ap-page-header">
        <h1 className="ap-page-title">New Invoice</h1>
        <span className="ap-inv-no">{invoiceNo}</span>
      </div>

      <div className="ap-inv-section">
        <h3 className="ap-section-label">Customer Details</h3>
        <input className="ap-input" placeholder="Customer name" value={customer.name}
          onChange={e => setCustomer(c => ({ ...c, name: e.target.value }))} />
        <input className="ap-input mt-6" placeholder="Phone number" value={customer.phone}
          onChange={e => setCustomer(c => ({ ...c, phone: e.target.value }))} />
        <input className="ap-input mt-6" placeholder="Address (optional)" value={customer.address}
          onChange={e => setCustomer(c => ({ ...c, address: e.target.value }))} />
      </div>

      <div className="ap-inv-section">
        <h3 className="ap-section-label">Items</h3>
        {lines.map((line, i) => (
          <div key={i} className="ap-line-row">
            <div className="ap-line-product">
              <select className="ap-input ap-line-select" value={line.productId}
                onChange={e => selectProduct(i, e.target.value)}>
                <option value="">— Select product —</option>
                {products.map(p => <option key={p.id} value={p.id}>{p.name} — TZS {Number(p.price).toLocaleString()}</option>)}
                <option value="custom">Custom item...</option>
              </select>
              {line.productId === 'custom' && (
                <input className="ap-input mt-4" placeholder="Item name" value={line.name}
                  onChange={e => setLine(i, 'name', e.target.value)} />
              )}
            </div>
            <div className="ap-line-controls">
              <input className="ap-input ap-line-price" type="number" placeholder="Price"
                value={line.price} onChange={e => setLine(i, 'price', e.target.value)} />
              <div className="ap-line-qty-wrap">
                <button className="ap-qty-btn" onClick={() => setLine(i, 'qty', Math.max(1, line.qty - 1))}>−</button>
                <span className="ap-qty-val">{line.qty}</span>
                <button className="ap-qty-btn" onClick={() => setLine(i, 'qty', line.qty + 1)}>+</button>
              </div>
              <span className="ap-line-total">{(Number(line.price) * Number(line.qty)).toLocaleString()}</span>
              {lines.length > 1 && (
                <button className="ap-icon-btn del" onClick={() => removeLine(i)}><FiX /></button>
              )}
            </div>
          </div>
        ))}
        <button className="ap-add-line" onClick={addLine}><FiPlus /> Add Item</button>
      </div>

      <div className="ap-inv-section">
        <h3 className="ap-section-label">Notes (optional)</h3>
        <textarea className="ap-input ap-textarea" rows={2} placeholder="Payment instructions, delivery notes..."
          value={notes} onChange={e => setNotes(e.target.value)} />
      </div>

      <div className="ap-inv-total-bar">
        <span>Total</span>
        <strong>TZS {total.toLocaleString()}</strong>
      </div>

      <div className="ap-inv-actions">
        <button className="ap-inv-btn pdf" onClick={handlePDF}><FiPrinter /> Download PDF</button>
        <button className="ap-inv-btn whatsapp" onClick={handleShare}><FiShare2 /> Share via WhatsApp</button>
      </div>

      {/* Print-only view */}
      <div className="print-invoice" ref={printRef}>
        <div className="pi-header">
          <h1>{BUSINESS.name}</h1>
          <p>{BUSINESS.phone} | {BUSINESS.email}</p>
          <p>{BUSINESS.address}</p>
        </div>
        <div className="pi-meta">
          <div><strong>INVOICE</strong><br /><span>{invoiceNo}</span></div>
          <div style={{ textAlign: 'right' }}><strong>Date</strong><br /><span>{date}</span></div>
        </div>
        {customer.name && (
          <div className="pi-customer">
            <strong>Bill To:</strong> {customer.name}<br />
            {customer.phone && <>{customer.phone}<br /></>}
            {customer.address}
          </div>
        )}
        <table className="pi-table">
          <thead><tr><th>Item</th><th>Qty</th><th>Price</th><th>Total</th></tr></thead>
          <tbody>
            {lines.filter(l => l.name || l.productId).map((l, i) => (
              <tr key={i}>
                <td>{l.name || products.find(p => String(p.id) === l.productId)?.name}</td>
                <td>{l.qty}</td>
                <td>{Number(l.price).toLocaleString()}</td>
                <td>{(Number(l.price) * Number(l.qty)).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr><td colSpan={3}><strong>TOTAL</strong></td><td><strong>TZS {total.toLocaleString()}</strong></td></tr></tfoot>
        </table>
        {notes && <p className="pi-notes">Notes: {notes}</p>}
        <p className="pi-thanks">Thank you for your business!</p>
      </div>
    </div>
  );
};

export default AdminInvoice;
